import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
var Portal = /*#__PURE__*/function (_React$Component) {
  function Portal() {
    _classCallCheck(this, Portal);
    return _callSuper(this, Portal, arguments);
  }
  _inherits(Portal, _React$Component);
  return _createClass(Portal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/ReactDOM.createPortal(this.props.children, this.props.container);
    }
  }]);
}(React.Component);
Portal.propTypes = {
  children: PropTypes.element.isRequired,
  container: PropTypes.any.isRequired
};
export default Portal;